var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProof = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "25px",
    viewBox: "0 0 21 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proof/16x16/ultra-dark",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(2.727273, 8.888889)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47035573,0.865700483 L0.509881423,0.865700483 C0.272727273,0.865700483 0.0592885375,1.05120773 0.0592885375,1.30628019 C0.0592885375,1.53816425 0.249011858,1.7468599 0.509881423,1.7468599 L4.47035573,1.7468599 C4.70750988,1.7468599 4.92094862,1.56135266 4.92094862,1.30628019 C4.92094862,1.07439614 4.70750988,0.865700483 4.47035573,0.865700483 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.58838142,21.3333333 L1.45239158,21.3333333 C0.650261296,21.3333333 0,20.7036495 0,19.9269025 L0,1.40643088 C0,0.629683881 0.650261296,0 1.45239158,0 L15.8203702,0 C16.622466,0 17.2727273,0.629683881 17.2727273,1.40643088 L17.2727273,12.6975065",
    id: "Stroke-1",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72727273,4.88888889 C2.72727273,5.12280702 2.92261458,5.33333333 3.19120962,5.33333333 L14.0815177,5.33333333 C14.325695,5.33333333 14.5454545,5.14619883 14.5454545,4.88888889 C14.5454545,4.65497076 14.3501127,4.44444444 14.0815177,4.44444444 L3.19120962,4.44444444 C2.94703231,4.44444444 2.72727273,4.63157895 2.72727273,4.88888889 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0815177,7.11111111 L3.19120962,7.11111111 C2.94703231,7.11111111 2.72727273,7.29824561 2.72727273,7.55555556 C2.72727273,7.78947368 2.92261458,8 3.19120962,8 L14.0815177,8 C14.325695,8 14.5454545,7.8128655 14.5454545,7.55555556 C14.5454545,7.29824561 14.3501127,7.11111111 14.0815177,7.11111111 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search/16x16/ultradark",
    transform: "translate(9.090909, 13.333333)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 4.05263158,
    cy: 4.05263158,
    r: 4.05263158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11999791,6.92411236 L9.19894528,6.92411236 L9.11999791,6.84516499 L9.11999791,6.42411236 L8.90947159,6.63463868 L8.69894528,6.42411236 L8.69894528,6.84516499 L8.61999791,6.92411236 L8.69894528,6.92411236 L8.69894528,10.8948308 L8.61999791,10.8948308 L8.69894528,10.9737782 L8.69894528,11.3948308 L8.90947159,11.1843045 L9.11999791,11.3948308 L9.11999791,10.9737782 L9.19894528,10.8948308 L9.11999791,10.8948308 L9.11999791,6.92411236 Z",
    id: "Rectangle-4",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(8.909472, 8.909472) rotate(-45.000000) translate(-8.909472, -8.909472) "
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProof);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/proof.bb89def73ccd4e0e457c69db9c6eff48.svg";